module.exports = __webpack_public_path__ + "static/media/boomer_boutique.616d748a.png";